export default "__VITE_ASSET__3nxhAqUW__"